import React from 'react';
import { headingClasses, textClasses, sectionClasses, cardClasses } from '../../styles/typography';

const TargetAudience = () => {
  const categories = [
    {
      title: 'Startup founders',
      description: "You're busy building your product – we'll handle the Play Store."
    },
    {
      title: 'Indie developers',
      description: 'No need to learn Google policies. Just upload and go live.'
    },
    {
      title: 'Freelancers & agencies',
      description: 'Deliver a published app to your client – no extra dev time.'
    },
    {
      title: 'Engineers with side projects',
      description: "Your weekend app deserves a home. We'll get it live fast."
    }
  ];

  return (
    <div className={`${sectionClasses.darkSection} pt-16 pb-24`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* כותרת ראשית */}
        <div className="mb-10 flex flex-col items-center w-full">
          <div className="text-center relative flex flex-col items-center justify-center w-full">
            <h2 className={headingClasses.hero}>
              Built for makers who want to launch,<br />
              not get stuck.
            </h2>
          </div>
        </div>

        {/* קטגוריות */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {categories.map((category, index) => (
            <div 
              key={index} 
              className={cardClasses.standard}
            >
              <div>
                <h3 className={headingClasses.secondary}>
                  {category.title}
                </h3>
                <p className={textClasses.body}>
                  {category.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TargetAudience; 